import { render, staticRenderFns } from "./IconClipboardCopySolid.vue?vue&type=template&id=484d3bc4"
import script from "./IconClipboardCopySolid.vue?vue&type=script&lang=js"
export * from "./IconClipboardCopySolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports